/**
 * Pushes the given virtPath to the GTM dataLayer.
 *
 * @param	path        	VirtPath to push.
 */
function pushVirtPath (path: string): void {
	const dataLayer: any = (<any>window).dataLayer || []
	if (path) {
		const virtPathPush = {
			'event': 'virtPath',
			'virtPath': path
		}

		dataLayer.push(virtPathPush)
	}
}

/**
 * Sends a Google Analytics event with the ga Object instead of using the
 * Google Tag Manager.
 *
 * @param	action   			Name of the action that was commited
 * @param	value    			The value itself that should be sent to analytics
 * @param	category    	Optional value that should determine a category in GA
 */
function sendGAEvent (action: string, value: string | boolean, category: string = 'Claim check'): void {
	const ga: Function = (<any>window).ga || function () {}
	ga('send', 'event', category, action, value)
}

export default {
	pushVirtPath,
	sendGAEvent
}
